(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-aviso-popup"]) return;
  try {
    
  if (!customElements.get('nibec-aviso-popup')) {
    class NibecAvisoPopup extends HTMLElement {
      connectedCallback() {
        this.dialogo = this.querySelector('dialog');
        if (!this.dialogo || typeof this.dialogo.showModal !== 'function') return;

        this.querySelectorAll('[data-cerrar]').forEach((boton) => boton.addEventListener('click', () => this.cerrar()));
        // Clic en el fondo: el evento llega con el propio <dialog> como target.
        this.dialogo.addEventListener('click', (evento) => {
          if (evento.target === this.dialogo) this.cerrar();
        });
        // Escape: se cierra con la misma animación que los botones.
        this.dialogo.addEventListener('cancel', (evento) => {
          evento.preventDefault();
          this.cerrar();
        });

        if (window.Shopify && Shopify.designMode) {
          this.escucharEditor();
          return;
        }
        if (this.hasAttribute('data-apagado') || !this.enVentana() || this.yaVisto()) return;

        const abrir = () => setTimeout(() => this.abrir(), 1200);
        if (document.readyState === 'complete') abrir();
        else window.addEventListener('load', abrir, { once: true });
      }

      // «AAAA-MM-DD HH:MM» de ahora en Santiago: se compara como texto contra los ajustes, sin cuentas de huso.
      ahoraEnChile() {
        const partes = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Santiago',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(new Date())
          .forEach((parte) => (partes[parte.type] = parte.value));
        return `${partes.year}-${partes.month}-${partes.day} ${partes.hour}:${partes.minute}`;
      }

      // Acepta «2026-10-20» o «2026-10-20 16:00». Una fecha sola en «Hasta» cubre el día completo.
      normalizar(valor, finDelDia) {
        const texto = (valor || '').trim().replace('T', ' ');
        if (!texto) return '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return `${texto} ${finDelDia ? '23:59' : '00:00'}`;
        return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(texto) ? texto : null;
      }

      enVentana() {
        const desde = this.normalizar(this.dataset.desde, false);
        const hasta = this.normalizar(this.dataset.hasta, true);
        if (desde === null || hasta === null) return false; // fecha mal escrita: mejor no mostrar que mostrar siempre
        const ahora = this.ahoraEnChile();
        return (!desde || ahora >= desde) && (!hasta || ahora <= hasta);
      }

      yaVisto() {
        try {
          return sessionStorage.getItem(this.dataset.clave) === '1';
        } catch (error) {
          return false;
        }
      }

      abrir() {
        if (this.dialogo.open) return;
        this.dialogo.classList.remove('is-cerrando');
        this.dialogo.showModal();
      }

      cerrar() {
        if (!this.dialogo.open) return;
        try {
          sessionStorage.setItem(this.dataset.clave, '1');
        } catch (error) {}
        const terminar = () => {
          this.dialogo.classList.remove('is-cerrando');
          this.dialogo.close();
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return terminar();
        this.dialogo.classList.add('is-cerrando');
        this.dialogo.addEventListener('animationend', terminar, { once: true });
        setTimeout(terminar, 250); // por si la animación no corre
      }

      escucharEditor() {
        const esEsta = (evento) => evento.detail && evento.detail.sectionId === this.dataset.sectionId;
        document.addEventListener('shopify:section:select', (evento) => esEsta(evento) && this.abrir());
        document.addEventListener('shopify:section:deselect', (evento) => esEsta(evento) && this.dialogo.close());
      }
    }

    customElements.define('nibec-aviso-popup', NibecAvisoPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-barra-countdown"] && !Shopify.designMode) return;
  try {
    
  class NibecCountdown extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (isNaN(end)) return;
      this.end = end;
      this.fields = {
        days: this.querySelector('[data-cd-days]'),
        hours: this.querySelector('[data-cd-hours]'),
        minutes: this.querySelector('[data-cd-minutes]'),
        seconds: this.querySelector('[data-cd-seconds]'),
      };
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      let diff = Math.max(0, this.end - Date.now());
      const day = Math.floor(diff / 86400000); diff -= day * 86400000;
      const hr = Math.floor(diff / 3600000); diff -= hr * 3600000;
      const min = Math.floor(diff / 60000); diff -= min * 60000;
      const sec = Math.floor(diff / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.fields.days) this.fields.days.textContent = pad(day);
      if (this.fields.hours) this.fields.hours.textContent = pad(hr);
      if (this.fields.minutes) this.fields.minutes.textContent = pad(min);
      if (this.fields.seconds) this.fields.seconds.textContent = pad(sec);
      if (this.end - Date.now() <= 0 && this.timer) clearInterval(this.timer);
    }
  }
  customElements.define('nibec-countdown', NibecCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-header"]) return;
  try {
    
  class NibecHeaderSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.scope = this.querySelector('.nibec-header__scope');
      this.input = this.querySelector('.nibec-header__search-input');
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.placeholderMovil();
      this.panel = this.querySelector('[data-nibec-sug]');
      if (this.panel && this.input && window.fetch) this.initSugerencias();
    }

    /* T-0457: en celular el campo dice «Producto o medida (ej. 180x90)»: la gente busca por medida. */
    placeholderMovil() {
      const movil = this.input && this.input.dataset.placeholderMovil;
      if (!movil || !window.matchMedia) return;
      const escritorio = this.input.dataset.placeholderEscritorio || this.input.getAttribute('placeholder') || ''; // data-placeholder-escritorio lo guarda el script en línea de arriba cuando ya puso el de celular
      const mq = window.matchMedia('(max-width: 749px)');
      const aplicar = () => this.input.setAttribute('placeholder', mq.matches ? movil : escritorio);
      aplicar();
      if (mq.addEventListener) mq.addEventListener('change', aplicar);
    }

    /* T-0457 · Sugerencias con foto y precio (búsqueda predictiva de Shopify). Patrón combobox:
       flechas para moverse, Enter abre la sugerencia marcada (sin marca, busca como siempre),
       Escape cierra. Todo se dibuja con textContent: nada del servidor se inyecta como HTML. */
    initSugerencias() {
      this.lista = this.panel.querySelector('.nibec-sug__lista');
      this.vacio = this.panel.querySelector('[data-sug-vacio]');
      this.todos = this.panel.querySelector('[data-sug-todos]');
      this.estado = this.querySelector('[data-sug-estado]');
      this.cache = new Map();
      this.activo = -1;
      this.temporizador = null;
      this.control = null;
      this.formato = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 });
      this.input.addEventListener('input', () => this.alEscribir());
      this.input.addEventListener('keydown', (e) => this.alTeclear(e));
      this.input.addEventListener('focus', () => {
        if (this.termino().length >= 2 && this.lista.childElementCount) this.abrir();
      });
      // Clic dentro del panel: el foco se queda en el campo (no se cierra antes del clic).
      this.panel.addEventListener('mousedown', (e) => e.preventDefault());
      this.panel.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-sug-pos]');
        if (a) this.medir(a);
      });
      this.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.cerrar();
        }, 200);
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.cerrar();
      });
    }

    termino() {
      return (this.input.value || '').trim();
    }

    alEscribir() {
      clearTimeout(this.temporizador);
      const t = this.termino();
      if (t.length < 2) {
        this.cerrar();
        return;
      }
      this.temporizador = setTimeout(() => this.buscar(t), 180);
    }

    async buscar(t) {
      if (this.cache.has(t)) {
        this.pintar(t, this.cache.get(t));
        return;
      }
      if (this.control) this.control.abort();
      this.control = typeof AbortController !== 'undefined' ? new AbortController() : null;
      this.anunciar('Buscando…');
      const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      const params = new URLSearchParams({
        q: t,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.sku,tag',
      });
      try {
        const r = await fetch(base + '.json?' + params.toString(), {
          signal: this.control ? this.control.signal : undefined,
          headers: { Accept: 'application/json' },
        });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        const d = await r.json();
        const productos = (((d || {}).resources || {}).results || {}).products || [];
        this.cache.set(t, productos);
        if (t === this.termino()) this.pintar(t, productos);
      } catch (error) {
        if (!error || error.name !== 'AbortError') this.cerrar();
      }
    }

    dinero(valor) {
      const n = Number(valor);
      return isFinite(n) && n > 0 ? '$' + this.formato.format(Math.round(n)) : '';
    }

    miniatura(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=112';
    }

    urlResultados(t) {
      const accion = this.form.getAttribute('action') || '/search';
      return accion + '?' + new URLSearchParams({ q: t, type: 'product' }).toString();
    }

    pintar(t, productos) {
      this.lista.textContent = '';
      this.activo = -1;
      this.input.removeAttribute('aria-activedescendant');
      productos.forEach((p, i) => {
        // La opción es el enlace (role="option" en <a> es válido); el <li> no aporta semántica.
        const li = document.createElement('li');
        li.className = 'nibec-sug__item';
        li.setAttribute('role', 'none');
        const a = document.createElement('a');
        a.className = 'nibec-sug__link';
        a.id = 'nibec-sug-op-' + i;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.href = p.url;
        a.tabIndex = -1;
        a.dataset.sugPos = String(i + 1);
        a.dataset.sugTitulo = p.title || '';
        a.dataset.hmId = 'busqueda-sugerencia';
        if (p.image) {
          const img = document.createElement('img');
          img.className = 'nibec-sug__img';
          img.src = this.miniatura(p.image);
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          img.decoding = 'async';
          a.appendChild(img);
        } else {
          const vacia = document.createElement('span');
          vacia.className = 'nibec-sug__img';
          vacia.setAttribute('aria-hidden', 'true');
          a.appendChild(vacia);
        }
        const texto = document.createElement('span');
        texto.className = 'nibec-sug__texto';
        const titulo = document.createElement('span');
        titulo.className = 'nibec-sug__titulo';
        titulo.textContent = p.title || '';
        texto.appendChild(titulo);
        const precio = document.createElement('span');
        precio.className = 'nibec-sug__precio';
        if (p.available === false) {
          precio.classList.add('nibec-sug__precio--agotado');
          precio.textContent = 'Agotado';
        } else {
          const actual = this.dinero(p.price);
          const antes = Number(p.compare_at_price_max) > Number(p.price) ? this.dinero(p.compare_at_price_max) : '';
          if (actual) {
            const span = document.createElement('span');
            span.textContent = actual;
            precio.appendChild(span);
          }
          if (antes) {
            precio.classList.add('nibec-sug__precio--oferta');
            const tachado = document.createElement('s');
            tachado.className = 'nibec-sug__antes';
            tachado.textContent = antes;
            const lector = document.createElement('span');
            lector.className = 'visually-hidden';
            lector.textContent = 'Precio normal';
            precio.appendChild(lector);
            precio.appendChild(tachado);
          }
        }
        texto.appendChild(precio);
        a.appendChild(texto);
        li.appendChild(a);
        this.lista.appendChild(li);
      });
      const hay = productos.length > 0;
      this.lista.hidden = !hay;
      this.vacio.hidden = hay;
      this.todos.hidden = !hay;
      if (hay) {
        this.todos.href = this.urlResultados(t);
        this.todos.textContent = 'Ver todos los resultados de «' + t + '»';
      } else {
        this.vacio.textContent = 'Sin resultados para «' + t + '». Prueba con otra palabra o una medida, como 180x90.';
      }
      this.anunciar(
        hay ? productos.length + (productos.length === 1 ? ' producto sugerido' : ' productos sugeridos') : 'Sin resultados'
      );
      this.abrir();
    }

    alTeclear(e) {
      const opciones = Array.prototype.slice.call(this.lista.querySelectorAll('[role="option"]'));
      if (e.key === 'Escape') {
        this.cerrar();
        return;
      }
      if (this.panel.hidden || !opciones.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const n = opciones.length;
        if (e.key === 'ArrowDown') this.activo = (this.activo + 1) % n;
        else this.activo = this.activo <= 0 ? n - 1 : this.activo - 1;
        opciones.forEach((op, i) => op.setAttribute('aria-selected', i === this.activo ? 'true' : 'false'));
        this.input.setAttribute('aria-activedescendant', opciones[this.activo].id);
        opciones[this.activo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.activo >= 0) {
        e.preventDefault();
        const a = opciones[this.activo];
        this.medir(a);
        window.location.href = a.href;
      }
    }

    abrir() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    cerrar() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activo = -1;
    }

    anunciar(texto) {
      if (this.estado) this.estado.textContent = texto;
    }

    medir(a) {
      const datos = {
        termino: this.termino(),
        posicion: Number(a.dataset.sugPos || 0),
        producto: a.dataset.sugTitulo || '',
        url: a.getAttribute('href') || '',
        dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador',
      };
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('nibec_busqueda_sugerencia', datos);
        }
      } catch (e) {}
      try {
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'nibec_busqueda_sugerencia' }, datos));
      } catch (e) {}
    }

    onSubmit(event) {
      const scopeUrl = this.scope && this.scope.value;
      if (!scopeUrl) return; // categoría "todas" → /search nativo
      // Categoría específica: ir a la colección, arrastrando el término de búsqueda
      event.preventDefault();
      const term = (this.input && this.input.value || '').trim();
      const dest = term ? scopeUrl + '?q=' + encodeURIComponent(term) : scopeUrl;
      window.location.href = dest;
    }
  }
  customElements.define('nibec-header-search', NibecHeaderSearch);

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Cerrar el dropdown de cotización al hacer clic fuera o con Escape
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.nibec-header__cotizar[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('details.nibec-header__cotizar[open]').forEach(function (d) {
        d.open = false;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-main-product"] && !Shopify.designMode) return;
  try {
    
  /* Visor de la galería de la ficha: clic en cualquier imagen → dialog a pantalla completa,
     con flechas, tira de miniaturas, zoom (clic/toque) y deslizar para cambiar en touch. */
  class NibecGaleria extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.nibec-lb');
      const datos = this.querySelector('[data-galeria-imagenes]');
      if (!this.dialog || !datos) return;
      try {
        this.imagenes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!this.imagenes.length) return;

      this.img = this.dialog.querySelector('[data-lb-img]');
      this.escena = this.dialog.querySelector('[data-lb-escena]');
      this.actual = this.dialog.querySelector('[data-lb-actual]');
      this.minis = Array.from(this.dialog.querySelectorAll('[data-lb-ir]'));
      this.indice = 0;

      this.mqPase = window.matchMedia('(max-width: 989px)');
      this.paseIdx = 0;
      this.querySelectorAll('.nibec-pdp__zoom').forEach((boton) => this.enlazar(boton));
      // W2: en celular la foto grande se desliza y las miniaturas la cambian (el visor se abre al tocar la foto).
      if (this.dataset.pase === 'true' && this.imagenes.length > 1) {
        const armar = () => {
          if (this.mqPase.matches) this.armarPase();
          this.modoPase();
        };
        armar();
        if (this.mqPase.addEventListener) this.mqPase.addEventListener('change', armar);
      }
      this.dialog.querySelector('[data-lb-cerrar]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-lb-ant]')?.addEventListener('click', () => this.ir(this.indice - 1));
      this.dialog.querySelector('[data-lb-sig]')?.addEventListener('click', () => this.ir(this.indice + 1));
      this.minis.forEach((mini) => mini.addEventListener('click', () => this.ir(Number(mini.dataset.lbIr))));

      this.dialog.addEventListener('close', () => {
        this.zoom(false);
        if (this.pase) this.irPase(this.indice, '', true);
        document.documentElement.style.removeProperty('overflow');
        if (this.origen) this.origen.focus(this.pase ? { preventScroll: true } : undefined);
      });
      this.dialog.addEventListener('keydown', (e) => {
        if (this.imagenes.length < 2 || this.dialog.classList.contains('is-zoom')) return;
        if (e.key === 'ArrowRight') this.ir(this.indice + 1);
        if (e.key === 'ArrowLeft') this.ir(this.indice - 1);
      });

      // Deslizar (solo touch/lápiz): con el mouse el clic es zoom, no navegación.
      this.escena.addEventListener('pointerdown', (e) => {
        this.inicio = { x: e.clientX, y: e.clientY, tipo: e.pointerType };
        this.deslizo = false;
      });
      this.escena.addEventListener('pointerup', (e) => {
        const i = this.inicio;
        if (!i || i.tipo === 'mouse' || this.dialog.classList.contains('is-zoom')) return;
        const dx = e.clientX - i.x;
        const dy = e.clientY - i.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && this.imagenes.length > 1) {
          this.deslizo = true;
          this.ir(this.indice + (dx < 0 ? 1 : -1));
        }
      });
      this.escena.addEventListener('click', (e) => {
        if (this.deslizo) {
          this.deslizo = false;
          return;
        }
        this.zoom(!this.dialog.classList.contains('is-zoom'), e);
      });
      // Con zoom y mouse, la imagen sigue al puntero (en touch se recorre con el scroll nativo).
      this.escena.addEventListener('mousemove', (e) => {
        if (!this.dialog.classList.contains('is-zoom')) return;
        const r = this.escena.getBoundingClientRect();
        this.escena.scrollLeft = ((e.clientX - r.left) / r.width) * (this.escena.scrollWidth - this.escena.clientWidth);
        this.escena.scrollTop = ((e.clientY - r.top) / r.height) * (this.escena.scrollHeight - this.escena.clientHeight);
      });

      this.ayuda = this.dialog.querySelector('.nibec-lb__ayuda');
      const mouse = window.matchMedia('(hover: hover)').matches;
      this.textos = mouse
        ? ['Haz clic en la imagen para hacer zoom', 'Mueve el mouse para recorrer · clic para alejar']
        : ['Toca la imagen para hacer zoom', 'Desliza para recorrer · toca para alejar'];
      if (this.ayuda) this.ayuda.textContent = this.textos[0];
    }

    enlazar(boton) {
      boton.addEventListener('click', () => {
        const indice = Number(boton.dataset.indice) || 0;
        // Con la pista armada (celular), la miniatura cambia la foto grande; la foto grande abre el visor.
        if (this.pase && this.mqPase.matches && boton.closest('.nibec-pdp__thumbs')) {
          this.irPase(indice, 'miniatura', false);
          return;
        }
        this.abrir(indice, boton);
      });
    }

    ancho(url, n) {
      return typeof url === 'string' && /width=\d+/.test(url) ? url.replace(/width=\d+/, 'width=' + n) : url;
    }

    armarPase() {
      if (this.pase) return;
      const marco = this.querySelector('.nibec-pdp__media--grande');
      const heroBtn = marco && marco.querySelector(':scope > .nibec-pdp__zoom');
      const lista = this.querySelector('.nibec-pdp__thumbs');
      if (!marco || !heroBtn || !lista) {
        this.setAttribute('data-pase-no', '');
        return;
      }
      const total = this.imagenes.length;
      const pista = document.createElement('div');
      pista.className = 'nibec-pdp__pista';
      pista.setAttribute('role', 'group');
      pista.setAttribute('aria-roledescription', 'carrusel');
      pista.setAttribute('aria-label', 'Fotos del producto');
      pista.setAttribute('data-hm-id', 'pdp-galeria-pista');
      marco.insertBefore(pista, heroBtn);
      pista.appendChild(heroBtn);
      this.imagenes.forEach((d, i) => {
        if (i === 0) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'nibec-pdp__zoom nibec-pdp__zoom--extra';
        b.dataset.indice = String(i);
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('aria-label', 'Ampliar imagen ' + (i + 1) + ' de ' + total);
        const img = new Image();
        img.className = 'nibec-pdp__img';
        img.alt = d.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.setAttribute('width', d.w);
        img.setAttribute('height', d.h);
        // Las fotos 2..N se piden recién al tocar la galería o con el navegador en reposo: la ficha no pesa más al cargar (la foto 1 manda el LCP).
        if (d.srcset) {
          const a = Math.min(628, d.w), c = Math.min(942, d.w);
          img.sizes = '92vw';
          img.dataset.srcset = this.ancho(d.src, a) + ' ' + a + 'w' + (c > a ? ', ' + this.ancho(d.src, c) + ' ' + c + 'w' : '');
          img.dataset.src = this.ancho(d.src, c);
        } else {
          img.dataset.src = d.src;
        }
        b.appendChild(img);
        pista.appendChild(b);
        this.enlazar(b);
      });
      // Miniatura de la 1.ª foto al inicio de la tira (hoy la tira empieza en la 2.ª).
      const d0 = this.imagenes[0];
      const li = document.createElement('li');
      li.className = 'nibec-pdp__media nibec-pdp__media--thumb nibec-pdp__media--cero';
      li.setAttribute('data-hm-id', 'pdp-galeria-miniatura');
      const b0 = document.createElement('button');
      b0.type = 'button';
      b0.className = 'nibec-pdp__zoom';
      b0.dataset.indice = '0';
      b0.setAttribute('aria-haspopup', 'dialog');
      b0.setAttribute('aria-label', 'Ampliar imagen 1 de ' + total);
      const i0 = new Image();
      i0.className = 'nibec-pdp__img';
      i0.alt = d0.alt || '';
      i0.loading = 'lazy';
      i0.setAttribute('width', d0.w);
      i0.setAttribute('height', d0.h);
      i0.src = this.ancho(d0.src, 306);
      b0.appendChild(i0);
      li.appendChild(b0);
      lista.insertBefore(li, lista.firstChild);
      this.enlazar(b0);
      lista.classList.add('nibec-pdp__thumbs--tira');
      // Overlay: lupa y contador fuera de la pista (si no, se irían con el deslizamiento).
      const lupa = document.createElement('span');
      lupa.className = 'nibec-pdp__pase-zoom';
      lupa.setAttribute('aria-hidden', 'true');
      lupa.innerHTML = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="8.5" cy="8.5" r="5.75"/><path d="M12.8 12.8 17.5 17.5M8.5 6v5M6 8.5h5"/></svg>';
      const cont = document.createElement('span');
      cont.className = 'nibec-pdp__contador';
      cont.setAttribute('aria-hidden', 'true');
      cont.innerHTML = '<span><span data-pase-actual>1</span> / ' + total + '</span>';
      const estado = document.createElement('span');
      estado.className = 'visually-hidden';
      estado.setAttribute('role', 'status');
      estado.setAttribute('aria-live', 'polite');
      marco.appendChild(lupa);
      marco.appendChild(cont);
      marco.appendChild(estado);
      this.pase = { pista, lista, marco, actual: cont.querySelector('[data-pase-actual]'), estado, thumbs: Array.from(lista.querySelectorAll('.nibec-pdp__media--thumb')), destino: null };
      this.setAttribute('data-pase-listo', '');
      const cargar = () => this.cargarPase();
      pista.addEventListener('pointerdown', cargar, { once: true, passive: true });
      pista.addEventListener('focusin', cargar, { once: true });
      if (document.readyState === 'complete') this.enReposo(cargar);
      else window.addEventListener('load', () => this.enReposo(cargar), { once: true });
      pista.addEventListener(
        'scroll',
        () => {
          if (this.pase.raf) return;
          this.pase.raf = requestAnimationFrame(() => {
            this.pase.raf = 0;
            const i = Math.round(pista.scrollLeft / Math.max(pista.clientWidth, 1));
            if (this.pase.destino !== null) {
              if (i === this.pase.destino) this.pase.destino = null;
              return;
            }
            if (i !== this.paseIdx && i >= 0 && i < total) this.marcar(i, 'deslizar');
          });
        },
        { passive: true }
      );
      this.marcar(0, '');
    }

    enReposo(fn) {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 4000 });
      else window.setTimeout(fn, 3000);
    }

    cargarPase() {
      if (!this.pase || this.pase.cargado) return;
      this.pase.cargado = true;
      this.pase.pista.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
      });
    }

    // Etiquetas de las miniaturas según el modo: con la pista, «ver»; sin ella (escritorio), «ampliar».
    modoPase() {
      if (!this.pase) return;
      const total = this.imagenes.length;
      const activo = this.mqPase.matches;
      this.pase.thumbs.forEach((li) => {
        const b = li.querySelector('.nibec-pdp__zoom');
        const n = Number(b.dataset.indice) + 1;
        if (activo) {
          b.removeAttribute('aria-haspopup');
          b.setAttribute('aria-label', 'Ver imagen ' + n + ' de ' + total);
        } else {
          b.setAttribute('aria-haspopup', 'dialog');
          b.setAttribute('aria-label', 'Ampliar imagen ' + n + ' de ' + total);
        }
      });
    }

    irPase(indice, origen, sinAnimar) {
      const p = this.pase;
      if (!p) return;
      const total = this.imagenes.length;
      const i = Math.min(Math.max(indice, 0), total - 1);
      const quieto = sinAnimar || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cargarPase();
      p.destino = i;
      p.pista.scrollTo({ left: i * p.pista.clientWidth, behavior: quieto ? 'auto' : 'smooth' });
      window.setTimeout(() => {
        if (p.destino === i) p.destino = null;
      }, 900);
      this.marcar(i, origen);
    }

    marcar(i, origen) {
      const p = this.pase;
      if (!p) return;
      const total = this.imagenes.length;
      this.paseIdx = i;
      p.actual.textContent = String(i + 1);
      p.estado.textContent = 'Imagen ' + (i + 1) + ' de ' + total;
      p.thumbs.forEach((li) => {
        const on = Number(li.querySelector('.nibec-pdp__zoom').dataset.indice) === i;
        li.classList.toggle('is-activa', on);
        if (on) {
          li.querySelector('.nibec-pdp__zoom').setAttribute('aria-current', 'true');
          // La tira se centra en la miniatura activa sin mover la página.
          const r = li.getBoundingClientRect();
          const l = p.lista.getBoundingClientRect();
          if (l.width > 0) p.lista.scrollBy({ left: r.left + r.width / 2 - (l.left + l.width / 2), behavior: 'auto' });
        } else {
          li.querySelector('.nibec-pdp__zoom').removeAttribute('aria-current');
        }
      });
      if (origen) {
        const d = { indice: i + 1, total: total, origen: origen, dispositivo: 'celular' };
        try {
          if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('nibec_galeria_pase', d);
        } catch (x) {}
        try {
          (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'nibec_galeria_pase' }, d));
        } catch (x) {}
      }
    }

    abrir(indice, origen) {
      this.origen = origen;
      this.ir(indice);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    ir(indice) {
      const total = this.imagenes.length;
      this.indice = ((indice % total) + total) % total;
      this.zoom(false);
      const d = this.imagenes[this.indice];
      this.img.srcset = d.srcset;
      this.img.src = d.src;
      // setAttribute y no .width: leer .width devuelve el ancho renderizado, no el del archivo.
      this.img.setAttribute('width', d.w);
      this.img.setAttribute('height', d.h);
      this.img.alt = d.alt;
      if (this.actual) this.actual.textContent = String(this.indice + 1);
      this.minis.forEach((mini, i) => {
        mini.setAttribute('aria-current', i === this.indice ? 'true' : 'false');
        if (i === this.indice && this.dialog.open) mini.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      // Precarga la siguiente para que la flecha no muestre un hueco mientras descarga.
      if (total > 1) {
        const s = this.imagenes[(this.indice + 1) % total];
        const pre = new Image();
        pre.sizes = '100vw';
        pre.srcset = s.srcset;
        pre.src = s.src;
      }
    }

    zoom(activar, e) {
      if (!this.dialog) return;
      if (this.ayuda && this.textos) this.ayuda.textContent = this.textos[activar ? 1 : 0];
      if (!activar) {
        this.dialog.classList.remove('is-zoom');
        this.escena.scrollTo(0, 0);
        return;
      }
      // La <img> llena la escena con object-fit: contain, así que la foto visible es una caja
      // más chica centrada adentro. Se calcula esa caja para saber dónde cayó el clic.
      const d = this.imagenes[this.indice];
      const caja = this.img.getBoundingClientRect();
      const ratio = d.w / d.h;
      const visibleW = Math.min(caja.width, caja.height * ratio);
      const visibleH = visibleW / ratio;
      const x0 = caja.left + (caja.width - visibleW) / 2;
      const y0 = caja.top + (caja.height - visibleH) / 2;
      const rx = e ? Math.min(Math.max((e.clientX - x0) / visibleW, 0), 1) : 0.5;
      const ry = e ? Math.min(Math.max((e.clientY - y0) / visibleH, 0), 1) : 0.5;
      // 2,5 veces lo visible, y nunca menos que 1,5 veces la escena: tiene que quedar qué recorrer.
      const ancho = Math.max(visibleW * 2.5, this.escena.clientWidth * 1.5);
      this.dialog.style.setProperty('--lb-zoom-w', Math.round(ancho) + 'px');
      this.dialog.classList.add('is-zoom');
      const img = this.img;
      this.escena.scrollLeft = rx * img.offsetWidth - this.escena.clientWidth / 2;
      this.escena.scrollTop = ry * img.offsetHeight - this.escena.clientHeight / 2;
    }
  }
  if (!customElements.get('nibec-galeria')) customElements.define('nibec-galeria', NibecGaleria);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-productos-destacados"] && !Shopify.designMode) return;
  try {
    
  class NibecDestacados extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      });
      this.querySelectorAll('[data-slider]').forEach((slider) => this.initSlider(slider));
    }

    activate(index) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.tab === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== index;
      });
      // El slider del panel recién mostrado se midió mal mientras estaba hidden
      // (scrollWidth/clientWidth = 0) → re-calcular flechas/progreso al activarlo.
      const active = this.panels.find((p) => p.dataset.panel === index);
      const slider = active && active.querySelector('[data-slider]');
      if (slider && slider._nibecUpdate) {
        requestAnimationFrame(() => slider._nibecUpdate());
      }
    }

    initSlider(slider) {
      const track = slider.querySelector('[data-track]');
      const prev = slider.querySelector('[data-prev]');
      const next = slider.querySelector('[data-next]');
      const thumb = slider.querySelector('[data-progress]');
      if (!track) return;

      const step = () => {
        const first = track.querySelector('li');
        return first ? first.offsetWidth + 16 : track.clientWidth * 0.8;
      };

      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      // Arrastrar con el mouse para desplazar (grab & drag). El touch usa scroll nativo.
      let dragActive = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;
      let dragPointerId = null;
      const DRAG_THRESHOLD = 6;

      // Evitar el drag nativo de imágenes/enlaces (si no, cancela el gesto sobre las cards)
      track.addEventListener('dragstart', (e) => e.preventDefault());

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragActive = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        dragPointerId = e.pointerId;
        // OJO: no capturar el puntero aquí. Si se captura, el 'click' se dispara
        // sobre el track y no sobre el <a> → la card no navegaría. Se captura recién
        // cuando el gesto supera el umbral (abajo), es decir, cuando ya es un arrastre.
      });

      track.addEventListener('pointermove', (e) => {
        if (!dragActive) return;
        const walk = e.clientX - dragStartX;
        if (!dragMoved) {
          if (Math.abs(walk) <= DRAG_THRESHOLD) return; // todavía es un click, no arrastre
          dragMoved = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(dragPointerId); } catch (err) {}
        }
        track.scrollLeft = dragStartScroll - walk;
      });

      const endDrag = () => {
        if (!dragActive) return;
        dragActive = false;
        track.classList.remove('is-dragging');
        if (dragPointerId != null && track.hasPointerCapture && track.hasPointerCapture(dragPointerId)) {
          track.releasePointerCapture(dragPointerId);
        }
        dragPointerId = null;
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // Si el gesto fue un arrastre, evitar que el click navegue por el enlace de la card
      track.addEventListener('click', (e) => {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        if (thumb) {
          thumb.style.width = Math.min(100, ratio * 100) + '%';
          const pct = max > 0 ? (track.scrollLeft / max) : 0;
          thumb.style.left = (pct * (100 - ratio * 100)) + '%';
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      slider._nibecUpdate = update;
    }
  }

  if (!customElements.get('nibec-destacados')) {
    customElements.define('nibec-destacados', NibecDestacados);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-resenas"] && !Shopify.designMode) return;
  try {
    
  /* Carrusel de reseñas. El scroll horizontal con scroll-snap ya funciona solo (touch y
     teclado); las flechas son un agregado para mouse. Si el JS no carga, la pista sigue
     siendo scrolleable: no se pierde contenido. */
  class NibecResenas extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      if (!this.pista) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.mover(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.mover(1));

      this.pista.addEventListener('scroll', () => this.actualizarFlechas(), { passive: true });
      this.actualizarFlechas();
    }

    get paso() {
      const item = this.pista.querySelector('.nibec-resenas__item');
      if (!item) return this.pista.clientWidth;
      const gap = parseFloat(getComputedStyle(this.pista).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    mover(direccion) {
      this.pista.scrollBy({ left: this.paso * direccion, behavior: 'smooth' });
    }

    actualizarFlechas() {
      const { scrollLeft, scrollWidth, clientWidth } = this.pista;
      // 1px de tolerancia: el scroll fraccionario nunca llega al máximo exacto.
      const alInicio = scrollLeft <= 1;
      const alFinal = scrollLeft + clientWidth >= scrollWidth - 1;
      this.querySelector('[data-prev]')?.toggleAttribute('disabled', alInicio);
      this.querySelector('[data-next]')?.toggleAttribute('disabled', alFinal);
    }
  }

  if (!customElements.get('nibec-resenas')) {
    customElements.define('nibec-resenas', NibecResenas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibec-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    /* Escritorio: aparece solo cuando el botón real de agregar al carrito ya pasó hacia ARRIBA, o sea
       cuando el usuario scrolleó más allá del buy box. No se ve al cargar.
       Celular (≤749px): también aparece mientras el botón real está más ABAJO de la pantalla,
       porque ahí la galería ocupa dos pantallas y el precio y el botón quedan ~1.600px abajo
       (Heatmap, 2-oct-2026: la mitad del tráfico es móvil). Se esconde mientras el botón real se ve. */
    class NibecStickyAtc extends HTMLElement {
      connectedCallback() {
        this.target = document.querySelector(this.dataset.target);
        if (!this.target) return;

        this.querySelector('[data-disparar]')?.addEventListener('click', () => {
          this.target.click();
        });

        /* Productos de cotización: el botón lleva al formulario de la misma ficha (un <details>
           con id `cotizar-<id>`), lo abre y baja hasta él. Si ese formulario no existe, el enlace
           sigue su href normal. El clic se mide igual que el resto de eventos del tema (assets/nibec-cotizacion.js):
           Shopify.analytics.publish -> lo recibe el píxel «GA4 · Bigbuda» del Admin (hay que
           suscribirlo ahí: ver .claude/pixeles/PENDIENTE-cotizar-barra-fija.js). Nibec no tiene GTM. */
        const cotizar = this.querySelector('[data-cotizar]');
        cotizar?.addEventListener('click', (evento) => {
          const datos = { handle: cotizar.dataset.handle || '', ubicacion: 'barra_fija_ficha' };
          try {
            if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
              Shopify.analytics.publish('nibec_cotizar_barra_fija', datos);
            }
          } catch (e) {}
          try {
            (window.dataLayer = window.dataLayer || []).push({
              event: 'cotizar_barra_fija',
              ubicacion_boton: datos.ubicacion,
              producto_handle: datos.handle
            });
          } catch (e) {}
          const detalle = document.getElementById(cotizar.dataset.cotizar);
          if (!detalle) return;
          evento.preventDefault();
          detalle.open = true;
          const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          /* El formulario es alto: se alinea por arriba (y se deja espacio para el header fijo)
             para que se vea el título y el primer campo. */
          detalle.style.scrollMarginTop = '120px';
          detalle.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
        });

        // T-0953 (20-oct-2026): con «Cotización única» la barra (que ahora trae «Agregar a mi cotización») se muestra desde la primera vista
        // también en tablet (hasta 989 px, donde la ficha va en una columna); antes en tablet solo aparecía después de pasar el botón.
        const movil = window.matchMedia(this.dataset.hasta ? '(max-width: ' + this.dataset.hasta + 'px)' : '(max-width: 749px)');
        this.observer = new IntersectionObserver(
          ([entrada]) => {
            const arriba = entrada.boundingClientRect.top < 0;
            const abajo = entrada.boundingClientRect.top > 0 && movil.matches;
            const paso = !entrada.isIntersecting && (arriba || abajo);
            this.classList.toggle('is-visible', paso);
            /* El host arranca aria-hidden; al mostrarse sigue oculto para asistivas porque
               es un duplicado del ATC real. Solo se conmuta inert para el foco. */
            this.toggleAttribute('inert', !paso);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    if (!customElements.get('nibec-sticky-atc')) {
      customElements.define('nibec-sticky-atc', NibecStickyAtc);
    }
  
  } catch(e) { console.error(e); }
})();
})();
